G.WorldMapCloudDynamicLayer = function(map) {

  var gatesMgr = G.Helpers.gatesMgr;

  Phaser.Group.call(this, game);
  this.position = map.position;
  this.map = map;

  this.freeInstances = [];

  this.activeGatesData = gatesMgr.getUnopenedGatesIds().map(function(gateId) {
    return gatesMgr.getGateObject(gateId);
  });

  this.onDestroy.add(function() {
    this.freeInstances.forEach(function(child) {
      child.destroy();
    });
  }, this);

  map.signals.onMapScrolled.add(G.Helpers.callOnThreshold(100, this.checkInstancesPlacements, this));
};

G.WorldMapCloudDynamicLayer.prototype = Object.create(Phaser.Group.prototype);

G.WorldMapCloudDynamicLayer.prototype.checkInstancesPlacements = function() {

  for (var i = 0, len = this.activeGatesData.length; i < len; i++) {
    var gateObject = this.activeGatesData[i];

    var wy = this.y + gateObject.getMapPosition().y;
    if ((wy > -500 && wy < game.height+500)) {
      if (!gateObject.instance && !gateObject.isOpen()) {
        this.placeInstance(gateObject);
      }
    } else if (gateObject.instance) {
      this.hideInstance(gateObject);
    }
  }; 

};

G.WorldMapCloudDynamicLayer.prototype.placeInstance = function(gateObject) {
  gateObject.instance = this.getFreeInstance();
  gateObject.instance.init(gateObject);
  this.add(gateObject.instance);
};

G.WorldMapCloudDynamicLayer.prototype.hideInstance = function(gateObject) {
  gateObject.instance.hide();
  gateObject.instance.parent.removeChild(gateObject.instance);
  this.freeInstances.push(gateObject.instance);
  gateObject.instance = null;
};

G.WorldMapCloudDynamicLayer.prototype.getFreeInstance = function() {
  return this.freeInstances.shift() || new G.WorldMapCloudDynamicLayer.CloudInstance();
};

//

G.WorldMapCloudDynamicLayer.CloudInstance = function() {
  var gatesMgr = G.Helpers.gatesMgr;

  Phaser.Group.call(this, game);

  this.state = game.state.getCurrentState();

  this.gateId = null;

  this.cloud1 = G.makeImage(-450,0,'cloud_1',0.5,this);
  this.cloud1.scale.setTo(2);
  this.c1tween = game.add.tween(this.cloud1.scale).to({x:2.1,y:2.1},4000,Phaser.Easing.Sinusoidal.InOut,true,0,-1,true);
  this.c1tween.timeline[0].dt = 2000;
  this.cloud1.alpha = 0.95;

  this.cloud2 = G.makeImage(0,50,'cloud_1',0.5,this);
  this.cloud2.scale.setTo(2);
  this.c2tween = game.add.tween(this.cloud2.scale).to({x:2.1,y:2.1},8000,Phaser.Easing.Sinusoidal.InOut,true,0,-1,true);
  this.c2tween.timeline[0].dt = 3000;
  this.cloud2.alpha = 0.95;

  this.cloud3 = G.makeImage(450,0,'cloud_1',0.5,this);
  this.cloud3.scale.setTo(-2,2); 
  this.c3tween = game.add.tween(this.cloud3.scale).to({x:-2.1,y:2.1},6000,Phaser.Easing.Sinusoidal.InOut,true,0,-1,true);
  this.c3tween.timeline[0].dt = 1500;
  this.cloud3.alpha = 0.95;

  this.fadeAwayBinding = G.Utils.cleanUpOnDestroy(this, gatesMgr.signals.onGateOpened.add(function(id) {
    if (id === this.gateId) this.fadeAway();
  }, this));
};

G.WorldMapCloudDynamicLayer.CloudInstance.prototype = Object.create(Phaser.Group.prototype);


G.WorldMapCloudDynamicLayer.CloudInstance.prototype.init = function(gateObject) {
  this.gateId = gateObject.getId();

  this.y = gateObject.getMapPosition().y - 370;

  this.fading = false;

  this.cloud1.x = -450;
  this.cloud1.y = 50;

  this.cloud2.x = 0;
  this.cloud2.y = 50;
  this.cloud2.alpha = 0.95;

  this.cloud3.x = 450;
  this.alpha = 1;
};

G.WorldMapCloudDynamicLayer.CloudInstance.prototype.hide = function() {

  if (this.fadingTweens) {
    this.fadingTweens.forEach(function(t) {t.stop()});
    this.fadingTweens = null;
  }

};

G.WorldMapCloudDynamicLayer.CloudInstance.prototype.fadeAway = function() {

  if (this.fading) return;

  this.fading = true;


  var t1 = game.add.tween(this.cloud1).to({x: -900,y:50},3000,Phaser.Easing.Sinusoidal.Out,true);
  var t2 = game.add.tween(this.cloud3).to({x: 900,y:50},3000,Phaser.Easing.Sinusoidal.Out,true);
  var t3 = game.add.tween(this.cloud2).to({alpha: 0},3000,Phaser.Easing.Sinusoidal.Out,true);
  var t4 = game.add.tween(this).to({alpha:0},2000,Phaser.Easing.Sinusoidal.In,true,1000);

  this.fadingTweens = [t1,t2,t3,t4];

};